'use client'

import React, { createContext, useContext, ReactNode } from 'react'

interface ConfigContextValue {
    config: IDomainConfig | null
}

const ConfigContext = createContext<ConfigContextValue>({ config: null })

export const useConfig = () => useContext(ConfigContext).config

interface ConfigProviderProps {
    children: ReactNode
    config: IDomainConfig | null
}

/**
 * ConfigProvider - Client Component
 *
 * Provides domain config to client components via React Context.
 * Populated from server-side in RootLayout (getDomainConfig or fallback).
 * Use useConfig() in PageHeader, LayoutLeftSidebar, PageContent, ProfileHeader, etc.
 */
export function ConfigProvider({ children, config }: ConfigProviderProps): React.JSX.Element {
    return (
        <ConfigContext.Provider value={{ config }}>
            {children}
        </ConfigContext.Provider>
    )
}
